<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  variant?: 'default' | 'secondary' | 'outline' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  disabled?: boolean;
}>();

const variants = {
  default: 'bg-slate-600 text-slate-50 hover:bg-slate-600/90',
  secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-100/80',
  outline: 'border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900',
  ghost: 'hover:bg-slate-100 hover:text-slate-900',
  link: 'text-slate-900 underline-offset-4 hover:underline',
};

const sizes = {
  default: 'h-10 px-4 py-2',
  sm: 'h-9 rounded-md px-3',
  lg: 'h-11 rounded-md px-8',
  icon: 'h-10 w-10',
};
</script>

<template>
  <button
    :class="`inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${variants[variant || 'default']} ${sizes[size || 'default']} ${className || ''}`"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>
